import React from 'react'

import { Button } from './styles'

function NavigationItem(props) {
  const { label, value, href, icon, onClick } = props
  return (
    <Button 
      data={href} 
      className={value === href ? 'selected' : ''} 
      onClick={onClick}
    >
      <span data={href} >{icon}</span>
      <span className='label' data={href} >{label}</span>
    </Button>
  )
}

export default NavigationItem
